    window.onscroll = function () {
      var t = document.querySelector(".btn-preview"),
        e = document.querySelector(".product-form__buttons"),
        normalButton = e.children[1].id === 'btn-preview-desktop' ? e.children[1] : e.children[0];
      var stickyButton = document.querySelector("#btn-preview");

      const ldOverInverse = document.querySelector(".customily-preview-button .ld-over-inverse");
      var normalButtonPosition = normalButton?.getBoundingClientRect();
      if (normalButtonPosition) {
        if (normalButtonPosition.top <= window.innerHeight && normalButtonPosition.bottom >= 50) {
          stickyButton.style.opacity = "0";
          stickyButton.parentElement.style.background = "none";
        } else {
          stickyButton.style.opacity = "1";
          stickyButton.parentElement.style.backgroundColor = "#fff";
          stickyButton.style.setProperty("-webkit-text-fill-color", "#fff", "important");
          //stickyButton.style.setProperty("border-color", "#f4993d ", "important");
        }
      }

    };    
    const urlCurrent = window.location.href;

const iconInnerHtml = `<svg width="160" height="160" viewBox="0 0 360 360" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
 <g clip-path="url(#clip0_3897_141669)">
 <rect width="360" height="360" rx="180" fill="#ff7a6bc2"/>
 <path opacity="0.2" d="M61.8991 163.556C58.3323 162.988 55.6742 161.412 53.9248 158.829C52.363 156.111 51.902 152.745 52.5415 148.732C53.2834 144.077 54.5416 139.833 56.3161 136.001C58.1161 132.008 60.5646 128.119 63.6616 124.333C66.9208 120.572 71.0033 116.861 75.9093 113.199C79.3648 110.293 82.1761 107.778 84.3432 105.654C86.698 103.396 88.3788 101.195 89.3854 99.0507C90.5798 96.772 91.3689 94.4287 91.7526 92.0209C92.4689 87.5262 91.3294 83.7233 88.3342 80.6123C85.501 77.5272 81.0041 75.4937 74.8433 74.5118C69.0068 73.5817 63.4606 73.4384 58.2045 74.0822C53.1105 74.7518 47.9952 76.0764 42.8587 78.056C38.2853 79.6316 34.3347 79.9073 31.0068 78.8831C27.8667 77.7242 25.5029 75.8661 23.9156 73.3087C22.3538 70.5908 21.6667 67.6007 21.8541 64.3385C22.0415 61.0764 23.2699 58.0624 25.5394 55.2967C27.8344 52.3704 31.2814 50.0392 35.8804 48.3031C43.1415 45.5098 50.9786 43.796 59.3918 43.1616C67.8051 42.5272 75.4973 42.7655 82.4687 43.8766C93.1689 45.5819 102.291 48.8462 109.834 53.6697C117.378 58.4931 122.852 64.3036 126.257 71.1012C129.824 77.9246 130.956 85.4297 129.651 93.6165C128.858 98.5928 127.386 103.132 125.237 107.233C123.087 111.335 120.045 115.294 116.112 119.112C112.204 122.769 107.042 126.473 100.626 130.224C94.935 133.596 90.3617 136.736 86.9063 139.642C83.4764 142.387 80.8699 145.181 79.0868 148.025C77.3293 150.707 75.9388 153.695 74.9151 156.989C74.045 159.319 72.5093 161.132 70.308 162.427C68.2688 163.748 65.4658 164.125 61.8991 163.556ZM52.8552 217.174C46.3702 216.141 41.4892 213.388 38.2122 208.915C35.0974 204.468 34.026 199.195 34.9982 193.095C35.9447 187.155 38.5766 182.637 42.8939 179.539C47.3989 176.306 52.8939 175.207 59.3789 176.24C65.8638 177.274 70.5827 180.001 73.5354 184.422C76.6759 188.709 77.7728 193.821 76.8263 199.761C75.8541 205.861 73.1966 210.54 68.8537 213.798C64.673 217.082 59.3402 218.208 52.8552 217.174Z" fill="#fbe3e0"/>
 <path opacity="0.2" d="M189.106 125.606C185.539 125.037 182.881 123.461 181.132 120.878C179.57 118.16 179.109 114.795 179.749 110.781C180.49 106.126 181.749 101.883 183.523 98.0503C185.323 94.0575 187.772 90.1681 190.869 86.382C194.128 82.6217 198.21 78.9104 203.116 75.248C206.572 72.3421 209.383 69.8273 211.55 67.7036C213.905 65.4453 215.586 63.2441 216.592 61.1001C217.787 58.8214 218.576 56.4782 218.96 54.0703C219.676 49.5756 218.536 45.7727 215.541 42.6617C212.708 39.5766 208.211 37.5431 202.05 36.5613C196.214 35.6311 190.668 35.4879 185.411 36.1316C180.318 36.8012 175.202 38.1258 170.066 40.1054C165.492 41.681 161.542 41.9567 158.214 40.9325C155.074 39.7737 152.71 37.9155 151.123 35.3581C149.561 32.6402 148.874 29.6502 149.061 26.388C149.249 23.1258 150.477 20.1118 152.746 17.3461C155.041 14.4198 158.488 12.0886 163.087 10.3525C170.348 7.55929 178.186 5.84546 186.599 5.21106C195.012 4.57666 202.704 4.81497 209.676 5.926C220.376 7.6313 229.498 10.8957 237.041 15.7191C244.585 20.5426 250.059 26.3531 253.464 33.1506C257.031 39.9741 258.163 47.4791 256.858 55.6659C256.065 60.6422 254.593 65.1811 252.444 69.2828C250.294 73.3844 247.252 77.3439 243.319 81.1613C239.411 84.8182 234.249 88.5221 227.833 92.273C222.142 95.6457 217.569 98.785 214.113 101.691C210.683 104.436 208.077 107.231 206.294 110.074C204.536 112.757 203.146 115.745 202.122 119.038C201.252 121.369 199.716 123.181 197.515 124.477C195.476 125.798 192.673 126.174 189.106 125.606ZM180.062 179.224C173.577 178.19 168.696 175.437 165.419 170.964C162.304 166.517 161.233 161.244 162.205 155.144C163.152 149.205 165.784 144.686 170.101 141.588C174.606 138.356 180.101 137.256 186.586 138.29C193.071 139.323 197.79 142.051 200.742 146.472C203.883 150.758 204.98 155.871 204.033 161.81C203.061 167.91 200.404 172.589 196.061 175.848C191.88 179.132 186.547 180.257 180.062 179.224Z" fill="#fbe3e0"/>
 <g filter="url(#filter0_d_3897_141669)">
 <rect x="68.4023" y="86.4" width="320" height="294" rx="32" fill="white"/>
 </g>
 <rect x="96.4043" y="155.2" width="428.4" height="43.2" rx="7.2" fill="#F5F5F6"/>
 <rect x="97.3043" y="250.499" width="52.2" height="52.2" rx="13.5" stroke="#ff7a6b" stroke-width="1.8"/>
 <rect x="158.504" y="250.499" width="52.2" height="52.2" rx="13.5" stroke="#EAEAEB" stroke-width="1.8"/>
 <rect x="219.704" y="250.499" width="52.2" height="52.2" rx="13.5" stroke="#EAEAEB" stroke-width="1.8"/>
 <rect x="280.904" y="250.499" width="52.2" height="52.2" rx="13.5" stroke="#EAEAEB" stroke-width="1.8"/>
 <rect x="342.104" y="250.499" width="52.2" height="52.2" rx="13.5" stroke="#EAEAEB" stroke-width="1.8"/>
 <path d="M136.272 256.61C137.258 255.951 138.418 255.599 139.605 255.599C140.393 255.599 141.173 255.754 141.901 256.056C142.629 256.357 143.29 256.799 143.848 257.356C144.405 257.914 144.847 258.575 145.148 259.303C145.45 260.031 145.605 260.811 145.605 261.599C145.605 262.786 145.253 263.946 144.594 264.933C143.935 265.919 142.997 266.688 141.901 267.142C140.805 267.597 139.598 267.715 138.434 267.484C137.271 267.252 136.201 266.681 135.362 265.842C134.523 265.003 133.952 263.934 133.72 262.77C133.489 261.606 133.608 260.399 134.062 259.303C134.516 258.207 135.285 257.27 136.272 256.61Z" fill="#ff7a6b"/>
 <path d="M138.9 262.346L141.637 259.511C141.756 259.389 141.918 259.32 142.087 259.32C142.255 259.32 142.417 259.389 142.536 259.511C142.596 259.573 142.644 259.645 142.676 259.726C142.708 259.806 142.725 259.892 142.725 259.979C142.725 260.066 142.708 260.153 142.676 260.233C142.644 260.313 142.596 260.386 142.536 260.447L139.347 263.744C139.228 263.866 139.068 263.934 138.9 263.935C138.816 263.935 138.733 263.919 138.655 263.886C138.578 263.853 138.507 263.805 138.447 263.744L136.948 262.188C136.881 262.129 136.827 262.056 136.789 261.974C136.75 261.892 136.729 261.803 136.726 261.713C136.722 261.622 136.737 261.531 136.769 261.447C136.801 261.362 136.85 261.285 136.912 261.221C136.974 261.157 137.048 261.106 137.13 261.073C137.212 261.04 137.3 261.025 137.388 261.028C137.476 261.032 137.562 261.054 137.641 261.094C137.72 261.133 137.79 261.189 137.848 261.258L138.9 262.346Z" fill="white"/>
 </g>
 <rect x="10" y="10" width="340" height="340" rx="170" stroke="#fbe3e0" stroke-width="20"/>
 <defs>
 <filter id="filter0_d_3897_141669" x="36.4023" y="58.4" width="400" height="374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
 <feFlood flood-opacity="0" result="BackgroundImageFix"/>
 <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
 <feOffset dx="8" dy="12"/>
 <feGaussianBlur stdDeviation="20"/>
 <feComposite in2="hardAlpha" operator="out"/>
 <feColorMatrix type="matrix" values="0 0 0 0 0.0778646 0 0 0 0 0.268565 0 0 0 0 0.2875 0 0 0 0.3 0"/>
 <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3897_141669"/>
 <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3897_141669" result="shape"/>
 </filter>
 <clipPath id="clip0_3897_141669">
 <rect width="360" height="360" rx="180" fill="white"/>
 </clipPath>
 </defs>
 </svg>`;
    !(function () {
      // part to handle store chosen options to storage
      //const metaItem = document.querySelector('meta[property="omega:product"]');
      //const productIdd = metaItem.content;
      
      const productIdd = $(".product_form.init").attr("data-product-id");
      const storageKey = "uid_customily";

      function ut(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }

      function st(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }

      function ct(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? st(Object(n), !0).forEach(function (e) {
                ut(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
            : st(Object(n)).forEach(function (e) {
                Object.defineProperty(
                  t,
                  e,
                  Object.getOwnPropertyDescriptor(n, e)
                );
              });
        }
        return t;
      }

      function ft(t, e) {
        var n = JSON.parse(JSON.stringify(t));
        return (n = ct(
          ct({}, n),
          {},
          ut({}, e.id, { name: e.name, value: e.value })
        ));
      }

      function lt(t) {
        var e = JSON.parse(localStorage.getItem(storageKey)) || [],
          n = productIdd;

        !(function (t, e, n) {
          var r = JSON.parse(JSON.stringify(t)),
            i = {};
          n.forEach(function (t) {
            switch (t.type) {
              case "checkbox":
              case "radio":
                if (!t.checked) break;
                i = ft(i, t);
                break;
              case "text":
              case "select-one":
                i = ft(i, t);
            }
          }),
            r.push({ product_id: e, properties: i }),
            localStorage.setItem(storageKey, JSON.stringify(r));
        })(
          e.filter(function (t) {
            return t.product_id !== n;
          }),
          n,
          t
        );
      }

      jQuery("body").on(
        "change",
        "#customily-options input, #customily-options select",
        function () {
          lt(
            document.querySelectorAll(
              "#customily-options input, #customily-options select"
            )
          );
        }
      );
    })();
    //const metaItem = document.querySelector('meta[property="omega:product"]');
    const productIdd = $(".product_form.init").attr("data-product-id");
    const storageKey = "uid_customily";
    function readingStoredOptions(prodId) {
      const allStoredCustomily = JSON.parse(
        localStorage.getItem(storageKey) || "[]"
      );
      return allStoredCustomily.find((i) => i.product_id === prodId);
    }

    const checkClickedElements = (ids) => {
      return Array.from(document.querySelectorAll(ids.join(",")))
        .filter((element) => {
          const elementType = element.type;
          if (elementType === "select-one" || elementType === "text") {
            return element.value;
          }
          if (elementType === "radio" || elementType === "checkbox") {
            return element.checked;
          }
        })
        .map((i) => i.id);
    };

    function handleSingleRoundOfFillingOptions(ids) {
      let allClickedElements = checkClickedElements(
        ids.map((i) => `#${i.elId}`)
      );
      // if we all set
      if (allClickedElements.length === ids.length) {
        return true;
      }
      // else we check the ids that have not been checked => loop through them and check if they exist => click
      const idsThatStillNeedCheck = ids.filter(
        (i) => !allClickedElements.includes(i.elId)
      );

      for (let index = 0; index < idsThatStillNeedCheck.length; index += 1) {
        const element = idsThatStillNeedCheck[index];
        const { elId: elementId, value } = element;
        const existedEl = document.getElementById(elementId);
        if (existedEl) {
          const elType = existedEl.type;
          if (elType === "radio" || elType === "checkbox") {
            existedEl.click();
            // existedEl.dispatchEvent(new Event("change")); // Dec 1st
          } else if (elType === "text") {
            existedEl.setAttribute("value", value);
            existedEl.dispatchEvent(new Event("input"));
          } else if (elType === "select-one") {
            existedEl.setAttribute("value", value);
            // existedEl.dispatchEvent(new Event("change")); // Dec 1st
          }
        }
      }
      allClickedElements = checkClickedElements(ids.map((i) => `#${i.elId}`));

      return allClickedElements.length === ids.length;
    }
    function handlePickedStoredOptions(ids) {
      for (let index = 0; index <= ids.length; index += 1) {
        setTimeout(() => {
          handleSingleRoundOfFillingOptions(ids);
        }, 100);
        if (index === ids.length) {
          setTimeout(() => {
            const parentOfLoadingEl = document.querySelector(
              ".product__column-sticky .gallery-wrap"
            );
            const childrenEl = document.querySelector(
              ".filling_customily_options"
            );
            if (childrenEl) {
              setTimeout(() => {
                parentOfLoadingEl.removeChild(childrenEl);
                document
                  .querySelector(
                    ".product__column-sticky .gallery-wrap .product__media-list"
                  )
                  .classList.remove("opcatiy--ten");
              }, 1500);
            }
          }, 300);
        }
      }
    }

    function createPopup() {
      var el = document.createElement("div");
      el.className = "uid_customily--popup_refill--modal_wrapper";
      var elModalCloseSvg = document.createElement("button");
      elModalCloseSvg.className = "uid_customily--poup--close_svg";
      elModalCloseSvg.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z" fill="#3B4148"></path></svg>`;
      var elModal = document.createElement("div");
      elModal.className = "uid_customily--popup_refill--modal";
      var elModalIcon = document.createElement("div");
      elModalIcon.className = "uid_customily--popup_refill--modal--icon";
      elModalIcon.innerHTML = iconInnerHtml;
      var elModalTitle = document.createElement("div");
      elModalTitle.className = "uid_customily--popup_refill--modal--title";
      elModalTitle.textContent =
        "Anna meidän säästää aikaasi";
      var elModalContent = document.createElement("div");
      elModalContent.className = "uid_customily--popup_refill--modal--content";
      elModalContent.innerHTML = `<p>Sinulla on aiempi muokkaus.<br> Haluatko täyttää sen automaattisesti?</p>`;
      var elModalController = document.createElement("div");
      elModalController.className =
        "uid_customily--popup_refill--modal--controller";
      var confirmBtn = document.createElement("button");
      confirmBtn.className = "uid_customily--popup_btn--confirm mobile_title";
      confirmBtn.textContent =
        "Kyllä, jatka";
      var closeBtn = document.createElement("span");
      closeBtn.className = "uid_customily--popup_btn--reject";
      closeBtn.textContent =
        "Ei, haluan aloittaa alusta";

      elModalController.appendChild(confirmBtn);
      elModalController.appendChild(closeBtn);

      elModal.appendChild(elModalCloseSvg);
      elModal.appendChild(elModalIcon);
      elModal.appendChild(elModalTitle);
      elModal.appendChild(elModalContent);
      elModal.appendChild(elModalController);
      el.appendChild(elModal);
      document.body.appendChild(el);
    }
    const storedCustomilyObject = readingStoredOptions(productIdd, storageKey);
    let runRefill = false;
    if (storedCustomilyObject && !urlCurrent.includes("customizationId=")) {
      createPopup();
      const closeFillCustomilyPopupHandler = () => {
        const popupElement = document.querySelector(
          ".uid_customily--popup_refill--modal_wrapper"
        );
        runRefill = false;
        return document.body.removeChild(popupElement);
      };
      const closeButton = document.querySelector(
        ".uid_customily--popup_btn--reject"
      );
      const closeSvg = document.querySelector(
        ".uid_customily--poup--close_svg"
      );
      if (closeButton) {
        closeButton.addEventListener("click", closeFillCustomilyPopupHandler);
      }
      if (closeSvg) {
        closeSvg.addEventListener("click", closeFillCustomilyPopupHandler);
      }
      const confirmHandler = () => {
        closeFillCustomilyPopupHandler();
        runRefill = true;
      };
      const confirmBtn = document.querySelector(
        ".uid_customily--popup_btn--confirm"
      );
      if (confirmBtn) {
        confirmBtn.addEventListener("click", confirmHandler);
      }
    }
    var customilyProductLoaded = false;



    const fillingCustomilyChoseItems = setInterval(() => {
      const customilyElement = document.querySelector("#customily-options");
      window.addEventListener("customily-product-loaded", function() {
    customilyProductLoaded = true;
    // Place your code here to execute when the event fires
    });
      
      if (customilyElement && runRefill && customilyProductLoaded) {
        // handling logic
        clearInterval(fillingCustomilyChoseItems);
        // create the loading element & insert
        const loadingEl = document.createElement("div");
        loadingEl.className = "filling_customily_options";
        loadingEl.innerHTML = `<span>Ladataan muokkausvaihtoehtoja</span><span class="ld ld-cycle ld-ring"></span>`;
        loadingEl.style = `z-index: 1111111;`;
        const parentOfLoadingEl = document.querySelector(
          ".product__column-sticky .gallery-wrap"
        );
        parentOfLoadingEl.appendChild(loadingEl);
        document
          .querySelector(
            ".product__column-sticky .gallery-wrap .product__media-list"
          )
          .classList.add("opcatiy--ten");
        const storedCustomilyObject = readingStoredOptions(
          productIdd,
          storageKey
        );
        if (!storedCustomilyObject) {
          return false;
        }
        const { properties } = storedCustomilyObject;
        const allIds = Object.keys(properties);
        const foundIds = allIds
          .map((i) => ({
            elId: i,
            existed: document.getElementById(i),
            value: properties[i].value,
          }))
          .filter((i) => i.value !== "");
        setTimeout(() => {
          handlePickedStoredOptions(foundIds);
        }, 500);
      }
    }, 100);
  
